<template>
    <div>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <div class="card-text">
                    <div class="media" v-for="(item,index) in specialtyGet.data" :key="index">
                        <a class="media-left" href="javascript:;">
                            <img :src="item.image" alt="" class="media-object" />
                        </a>
                        <div class="media-body">
                            <h4 class="media-heading" style="cursor: pointer"
                                v-b-modal.showSpecialty @click="selectSpecialty(item)"
                                v-text="item.name"></h4>
                            <div v-text="item.specialty"></div>
                            <a :href="item.document" download class="text-silver text-decoration-none"
                               v-text="specialtyGet.documentDownload"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="showSpecialty" size="xl" :title="selectedSpecialty.name" ok-only :ok-title="modalAgreeGet">
            <span v-text="specialtyGet.mainText"></span>
            <div>
                <span v-text="specialtyGet.target"></span>
                <ol v-if="selectedSpecialty.targets.length">
                    <li v-for="(item,index) in selectedSpecialty.targets" :key="index" v-text="item"></li>
                </ol>
                <span v-else v-text="errDataGet"></span>
            </div>
            <div>
                <span v-text="specialtyGet.result"></span>
                <ol v-if="selectedSpecialty.results.length">
                    <li v-for="(item,index) in selectedSpecialty.results" :key="index" v-text="item"></li>
                </ol>
                <span v-else v-text="errDataGet"></span>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["specialtyGet","errDataGet","modalAgreeGet"]),
        methods:{
            selectSpecialty(item){
                this.selectedSpecialty = item;
            }
        },
        data(){
            return{
                selectedSpecialty : {targets:[],results:[]}
            }
        }
    }
</script>